// Mock data store
let mockUsers = [];
let mockOtpStore = {};

// Helper function for delayed responses
const mockApiCall = (data, delay = 1000) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(data);
    }, delay);
  });
};

// Generate a random 4-digit OTP
const generateOTP = () => {
  return Math.floor(1000 + Math.random() * 9000).toString();
};

// Mock appointments data
const mockAppointments = [
  {
    id: 1,
    service: "Haircut & Styling",
    status: "Confirmed",
    date: "2024-03-20",
    time: "14:30",
    location: "Downtown Salon"
  },
  {
    id: 2,
    service: "Manicure & Pedicure",
    status: "Pending",
    date: "2024-03-25",
    time: "11:00",
    location: "Beauty Spa"
  },
  {
    id: 3,
    service: "Facial Treatment",
    status: "Cancelled",
    date: "2024-03-15",
    time: "16:00",
    location: "Wellness Center"
  }
];

// Add mock data for appointments and salons
const mockUpcomingAppointments = [
  ...Array.from({ length: 11 }, (_, i) => {
    const hasServices = i % 3 !== 1; // 2 out of 3 have services
    const hasPackages = i % 3 !== 2; // 2 out of 3 have packages
    const services = hasServices ? [
      {
        name: ['Haircut', 'Nails', 'Beard Trim', 'Facial', 'Color', 'Makeup', 'Massage', 'Spa', 'Waxing', 'Threading', 'Blow Dry'][i % 11],
        price: 50 + i * 5,
        duration: 30 + (i % 3) * 15,
      },
    ] : [];
    const packages = hasPackages ? [
      {
        name: `Package ${i + 1}`,
        price: 100 + i * 10,
        duration: 60 + (i % 2) * 30,
      },
    ] : [];
    const totalDuration = [...services, ...packages].reduce((sum, item) => sum + (item.duration || 0), 0);
    return {
      _id: `${i + 1}`,
      salon: {
        name: `Salon ${i + 1}`,
        logo: [
          'https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=facearea&w=400&h=250',
          'https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=facearea&w=400&h=250',
          'https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?auto=format&fit=facearea&w=400&h=250',
          'https://images.unsplash.com/photo-1464983953574-0892a716854b?auto=format&fit=facearea&w=400&h=250',
          'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=facearea&w=400&h=250',
          'https://images.unsplash.com/photo-1519125323398-675f0ddb6308?auto=format&fit=facearea&w=400&h=250',
          'https://images.unsplash.com/photo-1518717758536-85ae29035b6d?auto=format&fit=facearea&w=400&h=250',
          'https://images.unsplash.com/photo-1519985176271-adb1088fa94c?auto=format&fit=facearea&w=400&h=250',
          'https://images.unsplash.com/photo-1465101046530-73398c7f28ca?auto=format&fit=facearea&w=400&h=250',
          'https://images.unsplash.com/photo-1465101178521-c1a9136a3b99?auto=format&fit=facearea&w=400&h=250',
          'https://images.unsplash.com/photo-1465101046530-73398c7f28ca?auto=format&fit=facearea&w=400&h=250',
        ][i % 11],
        address: `123 Main St #${i + 1}`,
        username: `salon${i + 1}`,
      },
      combinedAppointmentTime: `2024-07-${(i + 1).toString().padStart(2, '0')}T14:00:00`,
      services,
      packages,
      totalPrice: 150 + i * 10,
      specialist: {
        name: ['Sarah', 'Lina', 'Mike', 'Anna', 'John', 'Emma', 'Olivia', 'Noah', 'Liam', 'Sophia', 'Mason'][i % 11],
        _id: `spec${i + 1}`,
      },
      totalDuration,
      status: 'approved',
    };
  }),
];
const mockPendingAppointments = [
  ...Array.from({ length: 4 }, (_, i) => {
    const hasServices = i % 2 === 0;
    const hasPackages = i % 2 === 1;
    const services = hasServices ? [
      {
        name: ['Nails', 'Facial', 'Spa', 'Massage'][i % 4],
        price: 40 + i * 5,
        duration: 30 + (i % 2) * 15,
      },
    ] : [];
    const packages = hasPackages ? [
      {
        name: `Pending Package ${i + 1}`,
        price: 90 + i * 10,
        duration: 45 + (i % 2) * 30,
      },
    ] : [];
    const totalDuration = [...services, ...packages].reduce((sum, item) => sum + (item.duration || 0), 0);
    return {
      _id: `p${i + 1}`,
      salon: {
        name: `Pending Salon ${i + 1}`,
        logo: [
          'https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=facearea&w=400&h=250',
          'https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=facearea&w=400&h=250',
          'https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?auto=format&fit=facearea&w=400&h=250',
          'https://images.unsplash.com/photo-1464983953574-0892a716854b?auto=format&fit=facearea&w=400&h=250',
        ][i % 4],
        address: `456 Elm St #${i + 1}`,
        username: `pending${i + 1}`,
      },
      combinedAppointmentTime: `2024-07-0${i + 1}T11:00:00`,
      services,
      packages,
      totalPrice: 120 + i * 10,
      specialist: {
        name: ['Lina', 'Anna', 'Emma', 'Olivia'][i % 4],
        _id: `specP${i + 1}`,
      },
      totalDuration,
      status: 'pending',
    };
  }),
];
const mockHistoryAppointments = [
  ...Array.from({ length: 3 }, (_, i) => {
    const hasServices = i % 2 === 1;
    const hasPackages = i % 2 === 0;
    const services = hasServices ? [
      {
        name: ['Beard Trim', 'Facial', 'Color'][i % 3],
        price: 60 + i * 5,
        duration: 30 + (i % 2) * 15,
      },
    ] : [];
    const packages = hasPackages ? [
      {
        name: `History Package ${i + 1}`,
        price: 110 + i * 10,
        duration: 75 + (i % 2) * 30,
      },
    ] : [];
    const totalDuration = [...services, ...packages].reduce((sum, item) => sum + (item.duration || 0), 0);
    return {
      _id: `h${i + 1}`,
      salon: {
        name: `History Salon ${i + 1}`,
        logo: [
          'https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?auto=format&fit=facearea&w=400&h=250',
          'https://images.unsplash.com/photo-1464983953574-0892a716854b?auto=format&fit=facearea&w=400&h=250',
          'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=facearea&w=400&h=250',
        ][i % 3],
        address: `789 Oak St #${i + 1}`,
        username: `history${i + 1}`,
      },
      combinedAppointmentTime: `2024-06-1${i + 5}T16:00:00`,
      services,
      packages,
      totalPrice: 170 + i * 10,
      specialist: {
        name: ['Mike', 'Anna', 'John'][i % 3],
        _id: `specH${i + 1}`,
      },
      totalDuration,
      status: 'completed',
    };
  }),
];
const mockViewedSalons = [
  {
    id: 's1',
    _id: 's1',
    name: 'Glamour Salon',
    username: 'glamour-salon',
    address: '123 Main St',
    logo: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=facearea&w=400&h=250',
  },
  {
    id: 's2',
    _id: 's2',
    name: 'Urban Beauty',
    username: 'urban-beauty',
    address: '456 Elm St',
    logo: 'https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=facearea&w=400&h=250',
  },
  {
    id: 's3',
    _id: 's3',
    name: 'Classic Cuts',
    username: 'classic-cuts',
    address: '789 Oak St',
    logo: 'https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?auto=format&fit=facearea&w=400&h=250',
  },
];

// Mock API implementations
export const mockApi = {
  // Login customer
  loginCustomer: async (data) => {
    console.log('Mock login with:', data);
    const { phone } = data;
    
    // Store OTP for this phone number
    mockOtpStore[phone] = generateOTP();
    console.log('Generated OTP:', mockOtpStore[phone]); // For testing purposes
    
    return mockApiCall({ 
      success: true, 
      message: 'OTP sent successfully' 
    });
  },

  // Create new customer
  createCustomer: async (data) => {
    console.log('Mock create customer with:', data);
    const { phone } = data;
    
    // Store OTP for this phone number
    mockOtpStore[phone] = generateOTP();
    console.log('Generated OTP:', mockOtpStore[phone]); // For testing purposes
    
    return mockApiCall({ 
      success: true, 
      message: 'OTP sent successfully' 
    });
  },

  // Verify OTP
  verifyOtp: async (data) => {
    console.log('Mock verify OTP with:', data);
    const { phone, otp } = data;
    
    // Check if OTP matches
    if (mockOtpStore[phone] === otp) {
      // Clear OTP after successful verification
      delete mockOtpStore[phone];
      
      return mockApiCall({ 
        id: 'mock-user-id', 
        success: true 
      });
    }
    
    return mockApiCall({ 
      success: false, 
      message: 'Invalid OTP' 
    });
  },

  // Resend OTP
  resendOtp: async (phone) => {
    console.log('Mock resend OTP to:', phone);
    
    // Generate new OTP
    mockOtpStore[phone] = generateOTP();
    console.log('New OTP:', mockOtpStore[phone]); // For testing purposes
    
    return mockApiCall({ 
      success: true, 
      message: 'OTP resent successfully' 
    });
  },

  // Get user data
  getUser: async () => {
    console.log('Mock get user');
    return mockApiCall({
      id: 'mock-user-id',
      name: 'Mock User',
      phone: '1234567890',
      gender: 'male',
      dateOfBirth: '1990-01-01',
      isLoggedIn: true
    });
  },

  getAppointments: async () => {
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    // For testing, always return empty array
    return {
      success: true,
      data: []
    };
  },

  getUpcomingAppointments: async () => mockApiCall(mockUpcomingAppointments),
  getPendingAppointments: async () => mockApiCall(mockPendingAppointments),
  getHistoryAppointments: async () => mockApiCall(mockHistoryAppointments),
  getViewedSalons: async () => mockApiCall(mockViewedSalons),
}; 